/* eslint-disable react/prop-types */
import {
    Box,
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
    Card,
    CardContent,
    CardActions,
    IconButton,
    Chip
} from '@mui/material';
import { IListPae, PaeServices } from '../../../services/api/action-plan/Pae';
import { useNavigate } from 'react-router-dom';
import { Delete, Edit } from '@mui/icons-material';
import { ConfirmationDialog } from '../../shared';
import { useState } from 'react';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';
// import { useAuthContext } from '../../../context';

interface TableActionPlansProps {
    data: IListPae[],
    onDelet: () => void,
    hasViewPermission?: boolean;
    hasEditPermission?: boolean;
    hasRemovePermission?: boolean;
}

export const TablePAE = ({ data, onDelet, hasViewPermission = false, hasEditPermission = false, hasRemovePermission = false }: TableActionPlansProps) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    // const { userData } = useAuthContext();
    // const permissoes = userData.permissoes;

    const handleDelet = (uuid: string | undefined) => {
        if (!hasRemovePermission) {
            return;
        }
        if (uuid !== undefined) {
            PaeServices.delet(uuid)
                .then((response) => {
                    if (response instanceof Error) {
                        console.log(response.message);
                    } else {
                        onDelet();
                    }
                });
        }
    };

    const [valueId, setValueID] = useState<string | undefined>(undefined);
    const [isDialogOpen, setDialogOpen] = useState(false);

    const toggleDialog = () => {
        setDialogOpen(!isDialogOpen);
    };

    const handleClickOpen = (key: string | undefined | null) => {
        if (key !== undefined && key !== null) {
            setValueID(key);
            toggleDialog();
        }
    };

    const MobilePaeCard = ({ item, handleClickOpen, navigate }: {
        item: IListPae;
        handleClickOpen: (key: string | undefined | null) => void;
        navigate: ReturnType<typeof useNavigate>;
    }) => (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: '15px' }}>
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ wordBreak: 'break-word', flex: 1, mr: 1, fontSize: smDown ? '1rem' : '1.125rem' }}
                    >
                        Plano de Ação (PAE)
                    </Typography>
                    {item.data_emissao && (
                        <Chip
                            label={`Emissão: ${formatDateWhitoutHour(item.data_emissao)}`}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ flexShrink: 0 }}
                        />
                    )}
                </Box>
                {item.data_emissao && (
                    <Typography
                        variant="body2"
                        component="div"
                        color="text.secondary"
                        sx={{ wordBreak: 'break-word', fontSize: smDown ? '0.8rem' : '0.875rem', mb: item.orgao_fiscalizador ? 1 : 0 }}
                    >
                        <Typography component="span" fontWeight="bold">Data de Emissão:</Typography> {formatDateWhitoutHour(item.data_emissao)}
                    </Typography>
                )}
                {item.orgao_fiscalizador && (
                    <Typography
                        variant="body2"
                        component="div"
                        color="text.secondary"
                        sx={{ wordBreak: 'break-word', fontSize: smDown ? '0.8rem' : '0.875rem' }}
                    >
                        <Typography component="span" fontWeight="bold">Órgão Fiscalizador:</Typography> {item.orgao_fiscalizador}
                    </Typography>
                )}
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end', p: 2, pt: 0, flexDirection: 'column', gap: 1 }}>
                {hasEditPermission || hasViewPermission ? (
                    <Button
                        sx={{ borderRadius: '35px' }}
                        variant='outlined'
                        startIcon={<Edit />}
                        color='success'
                        onClick={() => navigate(`detalhes/${item.uuid}`)}
                        fullWidth
                    >
                        Editar
                    </Button>
                ) : null}
                <Button
                    sx={{ borderRadius: '35px' }}
                    variant='outlined'
                    startIcon={<Delete />}
                    color='error'
                    onClick={() => handleClickOpen(item.uuid)}
                    fullWidth
                >
                    Remover
                </Button>
            </CardActions>
        </Card>
    );

    return (
        <Box component={Paper} variant='outlined' sx={{ borderRadius: '25px', overflowX: 'auto' }} flex={1} width={'100%'} p={smDown ? 1 : 1}>
            <Typography variant={smDown ? 'h6' : 'h5'} align={smDown ? 'center' : 'left'} mb={2}>
                Planos de Ação (PAE)
            </Typography>

            {smDown ? (
                data.length > 0 ? (
                    data.map((item, index) => (
                        <MobilePaeCard
                            key={item.uuid || index}
                            item={item}
                            handleClickOpen={handleClickOpen}
                            navigate={navigate}
                        />
                    ))
                ) : (
                    <Paper sx={{ p: 3, textAlign: 'center', borderRadius: '15px' }}>
                        <Typography color="text.secondary">
                            Nenhum resultado encontrado
                        </Typography>
                    </Paper>
                )
            ) : (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'>Data de Emissão</TableCell>
                            <TableCell align='center'>Órgão Fiscalizador</TableCell>
                            <TableCell align='center'>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.length > 0 ? (
                            data.map((item, index) =>
                                <TableRow key={item.uuid || index}>
                                    <TableCell align='center'><Typography>{formatDateWhitoutHour(item.data_emissao)}</Typography></TableCell>
                                    <TableCell align='center'><Typography>{item.orgao_fiscalizador}</Typography></TableCell>
                                    <TableCell align='center'>
                                        <Box
                                            display={'flex'}
                                            justifyContent={'center'}
                                            gap={1}
                                        >
                                            {hasEditPermission || hasViewPermission ? (
                                                <IconButton
                                                    color='success'
                                                    onClick={() => navigate(`detalhes/${item.uuid}`)}
                                                // disabled={!permissoes.includes('edit')}
                                                >
                                                    <Edit />
                                                </IconButton>
                                            ) : null}
                                            {hasRemovePermission && (
                                                <IconButton
                                                    color='error'
                                                    onClick={() => handleClickOpen(item.uuid)}
                                                // disabled={!permissoes.includes('remove')}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    <Typography component="span" color="text.secondary">
                                        Nenhum resultado encontrado
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            )}
            <ConfirmationDialog
                isOpen={isDialogOpen}
                onClose={toggleDialog}
                onConfirm={() => handleDelet(valueId)}
                title='Excluir Arquivo'
                message='Tem certeza que deseja excluir o documento?'
            />
        </Box>
    );
};